// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"594":"about","852":"orders"}[chunkId] || chunkId) + "." + {"278":"e40d09fe","594":"e7b25051","852":"aaf6c8cf"}[chunkId] + ".css";
};